
import { Options, mixins } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { maska } from 'maska'
import { IApp } from '@/utils/types'
import cloneDeep from 'lodash/cloneDeep'
import { ACTION_APP } from '@/store/actions'
import CLoading from '@/components/common/ui/CLoading.vue'
import BaseFormDialogMixin from '../common/mixins/BaseFormDialogMixin.vue'
import TagContent from '@/components/common/ui/TagContent.vue'
import TestModeSelector from '@/components/common/ui/TestModeSelector.vue'

@Options({
  components: { CLoading, TagContent, TestModeSelector },
  directives: { maska },
  emits: ['update:onSelect'],
})
export default class LIFFHowToSetupFormModal extends mixins(BaseFormDialogMixin) {
  @Prop()
  appConfig!: IApp

  form: IApp = {}
  step = 1
  isTestMode = false
  componentKey = 0

  get requiredRule() {
    const requiredRule = {
      liff_id: this.$t('validate.this_field_is_required', {
        placeholder: this.$t('label.traffic_source.liff_id'),
      }),
    }
    return requiredRule
  }

  @Watch('isTestMode', { immediate: true })
  isTestModeChange() {
    this.componentKey++
  }

  onSubmit() {
    this.$refs.formRef
      .validate()
      .then(async (success: boolean) => {
        if (!success) {
          return
        }

        await this.doSave()
      })
      .catch((error: unknown) => {
        console.log('error', error)
      })
  }

  async doSave() {
    const { dispatch } = this.$store
    let success = false
    success = await dispatch(ACTION_APP.UPDATE, {
      _id: this.form._id,
      ...this.form,
    })

    if (success) {
      this.$q.notify({
        message: this.$t('messages.saved'),
        color: 'positive',
      })
    }

    this.visible = false
  }

  getWebhookURL() {
    const baseUrl = process.env.VUE_APP_API_ENDPOINT
    let url = `${baseUrl}webhook/liff-app?app_id=${this.form._id}`
    if (this.isTestMode) {
      url = `${baseUrl}webhook/test/liff-app?app_id=${this.form._id}`
    }
    return url
  }

  onCancel() {
    this.visible = false
    this.goto('overview', { app_id: this.form._id })
  }

  goto(name: string, params = {}) {
    this.$router.push({
      name,
      params,
    })
  }

  created() {
    this.form = { ...this.form, ...cloneDeep(this.appConfig) }

    if (!this.form.liff_id || this.form.liff_id === '') {
      this.isTestMode = false
    } else {
      if (this.form.is_test_mode && this.form.liff_id_test === '') {
        this.isTestMode = true
      }
    }
  }
}
